// Dependencies
import React from 'react';
import radium from 'radium';
import { connect } from 'react-redux';
import _ from 'lodash';

import LeoForm from '../../../components/form/LeoForm.jsx';
import LeoInput from '../../../components/form/LeoInput.jsx';
import LeoSelect from '../../../components/form/LeoReactSelect';
import countryEnum from '../../../lib/country-enum.js';

import formService from '../../../lib/form-service';

import { updateTicketAddress } from '../../../redux/ticketAddressReducer';
import validate from '../../../lib/email-validation.js';
import { ThemeContext } from "../../../components/theme/Theme.jsx";
import { getCountryCodeFromTheme } from "../../../redux/customerReducer";
import LeoLabel from "../../../components/form/LeoLabel";

const defaultProps = {
	address: {
		countryCode: getCountryCodeFromTheme(),
		salutation: '',
		firstname: '',
		lastname: '',
		companyName: '',
		additionalInfo: '',
		phoneNumber: '',
		email: '',
		postalCode: '',
		city: '',
		street: '',
		houseNumber: '',
	},
};

class TicketAddressForm extends React.Component {
	static contextType = ThemeContext;

	constructor(props) {
		super(props);

		this.state = {
			eMailInfo: null,
		};
	}

	onEmailChange(e) {
		this.props.onTicketAddressChange(e);
		e.persist();
		if (!this.debounce) {
			this.debounce = _.debounce(() => {
				validate(formService.formatSpecificFieldValues(e.target.name, e.target.value))
					.then((msg) => this.setState({eMailInfo: msg}));
			}, 500);
		}
		this.debounce();
	}

	render() {
		const salutations = {
			MR: 'Herr',
			MS: 'Frau',
			COMPANY: 'Firma',
		};

		const additionalDropDownValuesString = this.context.themeManager.value('ticket-address', 'ticket-address-additional-dropdown_values', null);
		const additionalDropDownValues = additionalDropDownValuesString ? additionalDropDownValuesString.split('|') : null;

		const dropDownDefaultPlaceholder = this.context.themeManager.getThemeTextOrHardcodedDefault('dropDownPlaceholder');
		const additionalDropDownPlaceholder = this.context.themeManager
			.valueOrDefault('ticket-address', 'ticket-address-additional-dropdown_placeholder', dropDownDefaultPlaceholder);

		const functionDropDownValuesString = this.context.themeManager.value('ticket-address', 'ticket-address-function-dropdown_values', null);
		const functionDropDownValues = functionDropDownValuesString ? functionDropDownValuesString.split('|') : null;
		const functionDropDownPlaceholder = this.context.themeManager.valueOrDefault('ticket-address', 'ticket-address-function-dropdown_placeholder',
			dropDownDefaultPlaceholder);

		const countriesList = Object.entries(countryEnum)
			.sort((a, b) => a[1].localeCompare(b[1]));
		const address = Object.assign({}, this.props.address || defaultProps.address);
		const index = this.props.index;
		return (
			<LeoForm>
				<LeoLabel className={"visually-hidden"} id={"salutation_label_" + index}
						for={`ticket-address_salutation_${index}`} label={'Anrede'}/>
				<LeoSelect
					id={`ticket-address_salutation_${index}`}
					name="salutation"
					value={address.salutation}
					valueInput={salutations[address.salutation] ? salutations[address.salutation] : ''}
					onChange={this.props.onTicketAddressChange}
					placeholder="Anrede"
					options={
						Object.entries(salutations).map(([key, value]) => {
							return {
								value: key,
								label: value,
								isSelected: key === address.salutation,
							}
						})
					}
				>
				</LeoSelect>
				<LeoLabel className={"visually-hidden"} id={`ticket-address_companyName_label_${index}`}
						for={`ticket-address_companyName_${index}`} label={'Firma'}/>
				<LeoInput
					type="text"
					maxLength="255"
					id={`ticket-address_companyName_${index}`}
					name="companyName"
					value={address.companyName}
					onChange={this.props.onTicketAddressChange}
					placeholder="Firma"
					autoComplete="organization"
					errors={formService.findAddressErrorForField(this.props.errors,'companyName', 'Firma')}
				/>
				<LeoLabel className={"visually-hidden"} id={`ticket-address_firstname_label_${index}`}
						for={`ticket-address_firstname_${index}`} label={'Vorname *'}/>
				<LeoInput
					type="text"
					maxLength="255"
					id={`ticket-address_firstname_${index}`}
					name="firstname"
					value={address.firstname}
					onChange={this.props.onTicketAddressChange}
					placeholder="Vorname *"
					autoComplete="given-name"
					errors={formService.findAddressErrorForField(this.props.errors,'firstname', 'Vorname')}
				/>
				<LeoLabel className={"visually-hidden"} id={`ticket-address_lastname_label_${index}`}
						for={`ticket-address_lastname_${index}`} label={'Nachname *'}/>
				<LeoInput
					type="text"
					maxLength="255"
					id={`ticket-address_lastname_${index}`}
					name="lastname"
					value={address.lastname}
					onChange={this.props.onTicketAddressChange}
					placeholder="Nachname *"
					autoComplete="family-name"
					errors={formService.findAddressErrorForField(this.props.errors,'lastname', 'Nachname')}
				/>
				{this.props.showFunctionDropDown &&
					<>
						<LeoLabel className={"visually-hidden"} id={`ticket-address_function_label_${index}`}
								for={`ticket-address_function_${index}`} label={functionDropDownPlaceholder}/>
						<LeoSelect
							id={`ticket-address_function_${index}`}
							name="function"
							value={address.function ? address.function : ''}
							valueInput={address.function ? address.function : ''}
							onChange={this.props.onTicketAddressChange}
							placeholder={functionDropDownPlaceholder}
							errors={formService.findAddressErrorForField(this.props.errors,'function', functionDropDownPlaceholder.replace('*',''))}
							options={
								functionDropDownValues.map((value) => {
									return {
										value: value,
										label: value,
										isSelected: value === address.function,
									}
								})
							}
						>
						</LeoSelect>
					</>
				}
				{this.props.showAdditionalDropDown &&
					<>
					<LeoLabel className={"visually-hidden"} id={`ticket-address_additionalInfo_label_${index}`}
							for={`ticket-address_additionalInfo_${index}`} label={additionalDropDownPlaceholder}/>
					<LeoSelect
						id={`ticket-address_additionalInfo_${index}`}
						name="additionalInfo"
						value={address.additionalInfo ? address.additionalInfo : ''}
						valueInput={address.additionalInfo ? address.additionalInfo : ''}
						onChange={this.props.onTicketAddressChange}
						placeholder={additionalDropDownPlaceholder}
						errors={formService.findAddressErrorForField(this.props.errors,'additionalInfo', additionalDropDownPlaceholder.replace('*',''))}
						options={
							additionalDropDownValues.map((value) => {
								return {
									value: value,
									label: value,
									isSelected: value === address.function,
								}
							})
						}
					>
					</LeoSelect>
					</>
				}
				<LeoLabel className={"visually-hidden"} id={`ticket-address_phoneNumber_label_${index}`}
						for={`ticket-address_phoneNumber_${index}`} label={"Telefon für Rückfragen *"}/>
				<LeoInput
					type="text"
					maxLength="255"
					id={`ticket-address_phoneNumber_${index}`}
					name="phoneNumber"
					value={address.phoneNumber}
					onChange={this.props.onTicketAddressChange}
					placeholder="Telefon für Rückfragen *"
					autoComplete="phone"
					errors={formService.findAddressErrorForField(this.props.errors,'phoneNumber', 'Telefon für Rückfragen')}
				/>
				<LeoLabel className={"visually-hidden"} id={`ticket-address_email_label_${index}`}
						for={`ticket-address_email_${index}`} label={"Email"}/>
				<LeoInput
					type="email"
					maxLength="255"
					id={`ticket-address_email_${index}`}
					name="email"
					value={address.email}
					onChange={(e) => this.onEmailChange(e)}
					placeholder="Email"
					autoComplete="email"
					errors={formService.findAddressErrorForField(this.props.errors,'email', 'Email')}
					warn={!!this.state.eMailInfo}
					infoText={this.state.eMailInfo}
				/>
				<LeoLabel className={"visually-hidden"} id={`ticket-address_postalCode_label_${index}`}
						for={`ticket-address_postalCode_${index}`} label={"PLZ *"}/>
				<LeoInput
					type="text"
					maxLength="255"
					id={`ticket-address_postalCode_${index}`}
					name="postalCode"
					value={address.postalCode}
					onChange={this.props.onTicketAddressChange}
					placeholder="PLZ *"
					autoComplete="postal-code"
					errors={formService.findAddressErrorForField(this.props.errors,'postalCode', 'PLZ')}
				/>
				<LeoLabel className={"visually-hidden"} id={`ticket-address_city_label_${index}`}
						for={`ticket-address_city_${index}`} label={"Ort *"}/>
				<LeoInput
					type="text"
					maxLength="255"
					id={`ticket-address_city_${index}`}
					name="city"
					value={address.city}
					onChange={this.props.onTicketAddressChange}
					placeholder="Ort *"
					autoComplete="address-level2"
					errors={formService.findAddressErrorForField(this.props.errors,'city', 'Ort')}
				/>
				<LeoLabel className={"visually-hidden"} id={`ticket-address_street_label_${index}`}
						for={`ticket-address_street_${index}`} label={"Straße *"}/>
				<LeoInput
					type="text"
					maxLength="255"
					id={`ticket-address_street_${index}`}
					name="street"
					value={address.street}
					onChange={this.props.onTicketAddressChange}
					placeholder="Straße *"
					autoComplete="new-address-level3"
					errors={formService.findAddressErrorForField(this.props.errors,'street', 'Straße')}
				/>
				<LeoLabel className={"visually-hidden"} id={`ticket-address_houseNumber_label_${index}`}
						for={`ticket-address_houseNumber_${index}`} label={"Hausnummer *"}/>
				<LeoInput
					type="text"
					maxLength="255"
					id={`ticket-address_houseNumber_${index}`}
					name="houseNumber"
					value={address.houseNumber}
					onChange={this.props.onTicketAddressChange}
					placeholder="Hausnummer *"
					autoComplete="new-address-level4"
					errors={formService.findAddressErrorForField(this.props.errors,'houseNumber', 'Hausnummer')}
				/>
				<LeoLabel className={"visually-hidden"} id={`ticket-address_countryCode_label_${index}`} for={`ticket-address_countryCode_${index}`} label={'Land'}/>
				<LeoSelect
					id={`ticket-address_countryCode_${index}`}
					name="countryCode"
					value={address.countryCode}
					placeholder={'Land'}
					valueInput={countryEnum[address.countryCode] ? countryEnum[address.countryCode] : ''}
					onChange={this.props.onTicketAddressChange}
					options={
						countriesList.map(([key, value]) => {
							return {
								value: key,
								label: value,
								isSelected: key === address.countryCode,
							}
						})
					}
				>
				</LeoSelect>
			</LeoForm>
		);
	}
}

const RadiumTicketAddressForm = radium(TicketAddressForm);

const mapStateToProps = (state) => {
	const showAdditionalDropDown = state.ticketAddress.showTicketAddressAdditionalDropDown;
	const showFunctionDropDown = state.ticketAddress.showTicketAddressFunctionDropDown;
	return {
		showAdditionalDropDown,
		showFunctionDropDown,
	};
};

const mapDispatchToProps = (dispatch, ownProps) => ({
	onTicketAddressChange: (event) => {
		const value = formService.formatSpecificFieldValues(event.target.name, event.target.value);
		dispatch(updateTicketAddress(event.target.name, value, ownProps.ticketItemUuid));
	},
});

export default connect(
	mapStateToProps,
	mapDispatchToProps,
)(RadiumTicketAddressForm);
